<template>
  <div>
    <div v-if="!isChecking" class="content">
      <h1 aria-hidden="true" style="display: none">{{ $t('accountDeletion.pageTitle') }}</h1>

      <LoginLogo />
      <VContainer>
        <VRow>
          <VCol class="text-center">
            <VIcon icon="mdi-account-remove" size="64" color="red-darken-3" class="mb-4" />
          </VCol>
        </VRow>

        <VRow>
          <VCol class="text-center">
            <h2 class="mb-3">{{ $t('accountDeletion.pageTitle') }}</h2>
            <p class="text-medium-emphasis">{{ $t('accountDeletion.loginRequiredMessage') }}</p>
          </VCol>
        </VRow>

        <VRow>
          <VBtn
            id="delete-request-login-button"
            :to="loginRoute"
            color="primary"
            class="mt-4"
            block
            data-cy="delete-request-login-button"
          >
            {{ $t('accountDeletion.loginButton') }}
          </VBtn>
        </VRow>
      </VContainer>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js';
import { useLoginRedirect } from '@/components/login-redirect.js';
import LoginLogo from '@/routes/account/components/LoginLogo.vue';

export const DELETE_ACCOUNT_SESSION_KEY = 'tw__open_delete_account_dialog';
const CONSOLE_INDEX = '/console/index';

export default {
  name: 'AccountDeleteRequest',
  components: {
    LoginLogo,
  },
  data() {
    return {
      loginRoute: `/account/login`,
      isChecking: true,
    };
  },
  async beforeRouteEnter(to, from, next) {
    const authStore = useAuthStore();

    try {
      await authStore.refreshCognitoUser();
      // User is authenticated — set the flag and redirect via router (no page reload)
      window.sessionStorage.setItem(DELETE_ACCOUNT_SESSION_KEY, '1');
      next(CONSOLE_INDEX);
    } catch {
      // User is not authenticated — set flag, save post-login destination, show the page
      window.sessionStorage.setItem(DELETE_ACCOUNT_SESSION_KEY, '1');
      const { setLocation } = useLoginRedirect();
      setLocation(CONSOLE_INDEX);
      next(vm => { vm.isChecking = false; });
    }
  },
}
</script>

<style>
</style>
